import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../contexts/AuthContext";

type Props = {
  children: React.ReactNode;
};

const PublicRoute: React.FC<Props> = ({ children }) => {
  const { isAuthenticated } = useContext(UserContext);

  // Redirect logged-in users to the dashboard
  return isAuthenticated ? <Navigate to="/dashboard" /> : <>{children}</>;
};

export default PublicRoute;
